import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { GSIcon } from 'src/components/shared/GSIcon'

/** Filtering is in-memory here, so the search does not need dashboard's 700ms API debounce. */
const SEARCH_DEBOUNCE_MS = 200

/** Lines the search field up with the 36px `small` buttons that share the row. */
const HEADER_CONTROL_HEIGHT = 36

interface Props {
  searchQuery: string
  onSearchChange(value: string): void
  onRefresh(): void
}

/**
 * The filter row under the status tabs — the same strip as apps/dashboard's `ContractorsHeader`:
 * white, hairline rules top and bottom, controls in one centred row. Status moved out of here
 * into `CustomersTabs`, as the dashboard keeps lifecycle state in tabs and attribute filters in
 * the row.
 */
const CustomersTableToolbarComponent = ({ searchQuery, onSearchChange, onRefresh }: Props) => {
  return (
    <div
      css={tw`flex flex-row items-center gap-4 border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`}
    >
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={onSearchChange}
        height={HEADER_CONTROL_HEIGHT}
        debounceMs={SEARCH_DEBOUNCE_MS}
        inputDataTestId="customers-list-search-input"
        clearButtonDataTestId="customers-list-search-clear-btn"
      />
      {/* Refresh is an action rather than a filter, so it sits opposite the search. Stays
          because the interim token can expire mid-session; the dashboard has no equivalent. */}
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="customers-list-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const CustomersTableToolbar = memo(CustomersTableToolbarComponent)
